// import Swiper JS
import Swiper from 'swiper';
import { EffectFade } from 'swiper/modules';
import { Navigation, Pagination } from 'swiper/modules';

import StudioMap from './studio-map';

export default class GalleryBlock {

  public readonly wrapper: HTMLElement;
  swiper: Swiper;
  paginationSvg: SVGElement|null = null;

  constructor(wrapper: HTMLElement)
  {
    this.wrapper = wrapper;

    this.paginationSvg = this.wrapper.querySelector('svg');

    this.swiper = new Swiper(wrapper, {
      modules: [Navigation, Pagination, EffectFade],
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      effect: "fade",

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      loop: true,

      // on: {
      //   slideChange: () => {

      //     const navigationBullet = this.paginationSvg?.querySelector('[data-index="'+ this.swiper.realIndex+'"]') as SVGGElement|null;
      //     navigationBullet?.classList.add('is-active');
      //     // fraction.textContent = `${swiper.realIndex + 1} / ${slideCount}`;
      //   }
      // }
    });

    const studioMap = this.wrapper.parentElement?.querySelector('.studio-map');
    
    if(studioMap instanceof HTMLElement) {
      new StudioMap(studioMap, this.swiper);
    }
  }
}